package com.essntl.features.area.ui.addeditarea

import com.essntl.features.area.domain.model.AreaModel

sealed interface AddEditAreaEvent {
    data object GetAllCountries : AddEditAreaEvent
    data class GetArea(val id: String) : AddEditAreaEvent
    data class UpdateAreaFields(val area: AreaModel) : AddEditAreaEvent
    data object AddArea : AddEditAreaEvent
    data object EditArea : AddEditAreaEvent
    data object DeleteArea : AddEditAreaEvent
    data object ClearState : AddEditAreaEvent
    data class AddCountry(val title: String) : AddEditAreaEvent
}